<template>
<svg viewBox="0 0 20 20" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-fill-update-data`]" width="1em" height="1em" v-bind="$attrs"><path d="M17.7547 9.25098C18.1309 12.6268 16.2247 15.9655 12.9139 17.2568C10.5673 18.1717 8.15815 17.8681 6.17657 16.6299L4.65411 19.2686L2.3797 12.5557L8.98907 11.7598L7.30255 14.6787C8.68266 15.5121 10.4607 15.7393 12.077 15.1094C14.4791 14.1734 15.8237 11.6988 15.4324 9.25L17.7547 9.25098ZM18.1131 7.62305L11.3484 8.19043L12.9813 5.36035C11.6222 4.36892 9.70274 4.03639 7.92267 4.73047C5.52076 5.66687 4.17562 8.14208 4.5672 10.5908H2.24493C1.86858 7.21452 3.77419 3.87501 7.08575 2.58398C9.45283 1.66111 12.1524 2.06953 14.1492 3.33691L15.6834 0.681641L18.1131 7.62305Z"/></svg>
</template>
<script>

export default {
  name: 'IconFillUpdateData',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
